import React, { useState } from 'react';
import { TourManagerCard } from './components/TourManagerCard';
import { AbilityRadarChart } from './components/AbilityRadarChart';
export function App() {
  const [selectedManager, setSelectedManager] = useState(null);
  const tourManagers = [{
    id: 1,
    name: 'Michael Chen',
    title: 'Asia Specialist',
    photo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wSN47wFwNxTN1PbgjtUEzq/image.png',
    specializations: ['Asia', 'Food', 'Shopping', 'Culture'],
    experience: 8,
    rating: 4.8,
    rarity: 'Gold',
    stats: {
      toursCompleted: 124,
      customerSatisfaction: 98,
      languages: 5
    },
    abilities: {
      regionalKnowledge: 95,
      foodDining: 90,
      shoppingMarkets: 85,
      culturalActivities: 92,
      adventureOutdoor: 70,
      luxuryServices: 75,
      budgetPlanning: 80,
      languageSkills: 88
    }
  }];
  return <div className="min-h-screen w-full bg-slate-900 p-8" data-id="element-0">
      <div className="max-w-6xl mx-auto" data-id="element-1">
        <h1 className="text-3xl font-bold text-white mb-8" data-id="element-2">
          Tour Manager Collection
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-3">
          <div data-id="element-4">
            <TourManagerCard manager={tourManagers[0]} onClick={() => setSelectedManager(tourManagers[0])} data-id="element-5" />
          </div>
          <div className="bg-slate-800 rounded-lg p-6" data-id="element-6">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-7">
              Manager Abilities
            </h2>
            <div className="h-80" data-id="element-8">
              <AbilityRadarChart abilities={tourManagers[0].abilities} data-id="element-9" />
            </div>
          </div>
        </div>
      </div>
    </div>;
}